<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="gotobulksuspensiorevoke()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Bulk Suspension
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="d-flex justify-content-start button-style mt-3">

                <div class="col-xl-3 d-none d-md-block">
                </div>
                <div class="col-xl-5 padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                        style="margin-bottom: 1rem !important;">
                        <mat-label>Search</mat-label>
                        <div class="search-input-container">
                            <input formControlName="searchQuery" placeholder="Enter Customer Account Number" id="search"
                                matInput type="text" #searchInput>
                        </div>
                    </mat-form-field>
                    <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                        (click)="search()">
                        <mat-icon style="color: white;">search</mat-icon>
                    </button>

                </div>
                <button type="button" class="btn reset_btn" (click)="clearFilter()">
                    <i class="fa fa-refresh"></i> reset
                </button>
            </div>
            <div class="container mt-3" *ngIf="showdata">
                <div class="row">
                    <div class="col-12 ">
                        <span class="title_header_bar">Customer Details</span>
                    </div>
                </div>
                <div class="card card_content">
                    <div class="row">

                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Full Name</mat-label>
                                <input matInput appInputtext maxlength="25" formControlName="fullName"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Email</mat-label>
                                <input matInput maxlength="25" formControlName="email" placeholder="Enter Product Cost"
                                    class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-6 mt-4">
                            <mat-form-field appearance="fill" hideRequiredMarker>
                                <mat-label>Reference Number</mat-label>
                                <input matInput maxlength="25" formControlName="refrenceNumber"
                                    placeholder="Enter Product Id" class="col-10" autocomplete="off">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end button-style mt-3">
                        <button class="btn btn-primary mb-2 mr-5" type="button" (click)="suspend()" matButton>
                            <i class="fa fa-add"></i> Add</button>
                    </div>



                </div>

            </div>
            <div *ngIf="noDataFound && !showdata" class="no-data-message">
                <p>No data found</p>
            </div>
            <div class="container mt-3" *ngIf="showsuspendtable">
                <div class="row">
                    <div class="col-12 ">
                        <span class="title_header_bar">Bulk Suspension</span>
                    </div>
                </div>
                <div class="card card_content">
                    <div class="table-responsive table-container mt-2 mb-4">
                        <mat-table #table [dataSource]="dataSource" class="mat-table ">

                            <ng-container matColumnDef="FullName">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;"> Full
                                    Name</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                    <p class="text-truncate txtalign">{{dataField.fullName}} </p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="Email">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Email</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 5%;text-align: center;">
                                    <p class="text-truncate txtalign"> {{dataField.email}}</p>
                                </mat-cell>
                            </ng-container>

                            <ng-container matColumnDef="ReferenceNumber">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;"> Reference
                                    Number</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;text-align: center;">
                                    <p class="text-truncate txtalign">{{dataField.refrenceNumber}} </p>
                                </mat-cell>
                            </ng-container>
                            <ng-container matColumnDef="SuspendCustomer">
                                <mat-header-cell *matHeaderCellDef style="text-align: center;">Suspend
                                    Customer</mat-header-cell>
                                <mat-cell *matCellDef="let dataField" style="width: 8%;margin: 0;padding: 0;">

                                    <div class="text-truncate text-center">
                                        <div>
                                            <mat-checkbox [checked]="dataField.isSuspend" style="transform: scale(1.3);"
                                                (change)="clickaction(dataField)" color="primary"
                                                style="background-color: white;"></mat-checkbox>
                                        </div>
                                    </div>
                                </mat-cell>
                            </ng-container>



                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                            <mat-row *matRowDef="let row; columns: displayedColumns;  " matRipple>
                            </mat-row>
                        </mat-table>
                        <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                            <p>No data found</p>
                        </div>
                    </div>
                    <div class="d-flex justify-content-end button-style mt-3">
                        <button class="btn btn-primary mb-3" type="button" (click)="suspenduser()" matButton>
                            Submit</button>
                    </div>
                </div>
            </div>

        </form>

    </div>

</div>